import { BasicAutocompleteField } from '@forgeglobal/design-framework'
import { InvestorShareholderOpts } from 'util/Enums'
import React from 'react'

export const InvestorShareholderField: React.FC<{ name: string; label: string }> = ({ name, label }) => {
  return <BasicAutocompleteField name={name} label={label} multiple={true} options={InvestorShareholderOpts} />
}
